class WorkInstructionDTO {
  _id;
  title;
  description;
  steps;
  packageId;
  order;

  constructor(data) {
    this._id = data._id || data.id;
    this.title = data.title;
    this.description = data.description;
    this.steps = data.steps || [];
    this.packageId = data.packageId;
    if (data.order != null) {
      this.order = data.order;
    }
  }
}

module.exports = WorkInstructionDTO;
